import { useState } from "react";
import { C, FONT } from "../theme";

// Lightweight, non-blocking cookie notice. We only set one strictly-necessary
// cookie (geo_session, HttpOnly auth) — which is consent-exempt under GDPR/
// ePrivacy — so this is an informational notice, not a consent gate. If non-
// essential cookies/analytics are ever added, upgrade this to an accept/reject
// consent banner (and gate those scripts on consent). See TODO.md.
const KEY = "geo_cookie_notice_ack";

export function CookieNotice() {
  const [dismissed, setDismissed] = useState(() => {
    try {
      return localStorage.getItem(KEY) === "1";
    } catch {
      return false;
    }
  });
  if (dismissed) return null;

  const ack = () => {
    try {
      localStorage.setItem(KEY, "1");
    } catch {
      /* ignore */
    }
    setDismissed(true);
  };

  return (
    <div
      style={{
        position: "fixed",
        bottom: 16,
        left: 16,
        right: 16,
        maxWidth: 720,
        margin: "0 auto",
        display: "flex",
        alignItems: "center",
        gap: 16,
        flexWrap: "wrap",
        justifyContent: "center",
        background: C.panel,
        border: `1px solid ${C.line3}`,
        borderRadius: 10,
        padding: "12px 16px",
        color: C.muted,
        fontFamily: FONT,
        fontSize: 12.5,
        lineHeight: 1.6,
        boxShadow: "0 8px 30px rgba(0,0,0,.45)",
        zIndex: 9990,
      }}
    >
      <span style={{ flex: 1, minWidth: 240 }}>
        We use a single essential cookie to keep you signed in — no tracking or ads. See our{" "}
        <a href="/privacy" style={{ color: C.ac, textDecoration: "underline" }}>Privacy Policy</a>.
      </span>
      <button
        onClick={ack}
        style={{ flex: "none", background: C.ac, border: "none", color: C.acInk, padding: "8px 18px", borderRadius: 6, font: `700 12px ${FONT}`, cursor: "pointer" }}
      >
        Got it
      </button>
    </div>
  );
}
